const mediaData = [
  {
    title: '七月黑料每日大赛总决赛精彩回顾',
    desc: '本月大赛最强选手巅峰对决，全程高能不容错过',
    duration: '12:38',
    views: '28.6万',
    img: 'https://readdy.ai/api/search-image?query=Entertainment%20competition%20grand%20finale%20stage%20with%20dramatic%20spotlight%20and%20confetti%2C%20dark%20atmospheric%20arena%2C%20golden%20trophy%20centerpiece%2C%20cinematic%20event%20photography%2C%20warm%20crimson%20and%20gold%20accents&width=700&height=400&seq=media-01-final&orientation=landscape',
  },
  {
    title: '明星后台独家专访 · 你不知道的那些事',
    desc: '多位明星后台独家对话，揭秘不为人知的幕后故事',
    duration: '18:24',
    views: '21.3万',
    img: 'https://readdy.ai/api/search-image?query=Backstage%20interview%20scene%20with%20soft%20dramatic%20lighting%2C%20celebrity%20portrait%20setup%2C%20dark%20atmospheric%20environment%2C%20professional%20photography%20studio%20vibe%2C%20warm%20ambient%20tones&width=700&height=400&seq=media-02-interview&orientation=landscape',
  },
  {
    title: '综艺名场面合集 · 笑到停不下来',
    desc: '年度最搞笑的综艺片段合集，全程高能预警',
    duration: '08:56',
    views: '17.8万',
    img: 'https://readdy.ai/api/search-image?query=Funny%20entertainment%20variety%20show%20moment%2C%20comedic%20studio%20scene%20with%20colorful%20lights%2C%20energetic%20atmosphere%2C%20laughter%20and%20joy%2C%20bright%20warm%20lighting%2C%20professional%20broadcast%20production&width=700&height=400&seq=media-03-variety&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">精彩视频</h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600">
            精选热门视频内容，点击即可在线观看
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {mediaData.map((item, idx) => (
            <article
              key={idx}
              className="group bg-background-50 border border-background-300/30 rounded-xl overflow-hidden transition-all hover:border-primary-500/20 cursor-pointer"
            >
              {/* Video thumbnail */}
              <div className="relative w-full aspect-video overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                {/* Play button overlay */}
                <div className="absolute inset-0 flex items-center justify-center bg-background-950/30 group-hover:bg-background-950/40 transition-colors">
                  <div className="w-14 h-14 rounded-full bg-primary-500/90 flex items-center justify-center group-hover:bg-primary-500 transition-colors">
                    <i className="ri-play-fill text-2xl text-background-50 ml-0.5"></i>
                  </div>
                </div>
                {/* Duration badge */}
                <div className="absolute bottom-3 right-3 bg-background-950/80 backdrop-blur-sm rounded-md px-2.5 py-1">
                  <span className="text-xs text-foreground-700 whitespace-nowrap">{item.duration}</span>
                </div>
              </div>

              {/* Info */}
              <div className="p-4">
                <h3 className="text-sm font-heading font-bold text-foreground-900 group-hover:text-primary-400 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <p className="mt-1.5 text-xs text-foreground-600 line-clamp-2">
                  {item.desc}
                </p>
                <div className="mt-3 flex items-center gap-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {item.views}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}